import { useApiMutation } from "@/hooks/use-api";
import {
  Dashboard,
  DashboardPopulated,
  DashboardCreate,
  DashboardUpdate,
} from "@/models/dashboard";
import { ExportCreate } from "@/models/export";
import { createResourceApi } from "./factory";

// Create standard CRUD hooks using the factory
const dashboardApi = createResourceApi<Dashboard, DashboardCreate, DashboardUpdate>({
  resourcePath: "dashboards",
  requireWorkspace: true,
});

// Export individual hooks for backward compatibility
export const useDashboards = dashboardApi.useList;
export const useCreateDashboard = () => dashboardApi.useCreate();
export const useUpdateDashboard = dashboardApi.useUpdate;
export const useDeleteDashboard = dashboardApi.useDelete;

/** @deprecated Use useUpdateDashboard instead */
export const useUpdateDashboardWithWidgets = useUpdateDashboard;

/**
 * Hook to get a single dashboard by ID with its widgets.
 * Uses fields=*.* to include child widgets via backlink relation.
 */
export const useDashboard = (id?: string) => {
  const api = createResourceApi<DashboardPopulated>({
    resourcePath: "dashboards",
    singleParams: { fields: "*.*" },
    requireWorkspace: true,
  });
  return api.useOne(id);
};

export const useDashboardExport = () =>
  useApiMutation<any, ExportCreate>({
    url: "exports",
    method: "POST",
  });
